import { render } from "./ListTaxAddressModal.vue?vue&type=template&id=1f11a4ae&scoped=true"
import script from "./ListTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./ListTaxAddressModal.vue?vue&type=script&lang=js"

import "./ListTaxAddressModal.vue?vue&type=style&index=0&id=1f11a4ae&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f11a4ae"]])

export default __exports__